import axiosBackEnd from "../../config/axios/axios-back-end";

// Self service - get all properties
const getAllProperties = async () => {
  const response = await axiosBackEnd.get("/api/onboarding/properties");
  return response.data;
};

// get single property depricate
const getPropertyById = async (propertyId) => {
  const response = await axiosBackEnd.get(
    `/api/onboarding/properties/${propertyId}`,
  );
  return response.data;
};

// Self service - get property by customer
const getPropertiesByCustomer = async (customerId) => {
  const response = await axiosBackEnd.get(
    `/api/onboarding/customers/${customerId}/properties`,
  );
  return response.data;
};

const approveProperty = async (data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/properties/approve`,
    data,
  );
  return res.data;
};

const approveSingleProperty = async (propertyId, data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/properties/${propertyId}/approve`,
    data,
  );
  return res.data;
};

const requestValidationProperty = async (data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/properties/validate`,
    data,
  );
  return res.data;
};

const removeProperties = async (data) => {
  const res = await axiosBackEnd.post(
    `/api/onboarding/properties/remove`,
    data,
  );
  return res.data;
};

const addProperty = async (data) => {
  const { customerId, propertyData } = data;
  const res = await axiosBackEnd.post(
    `/api/onboarding/properties/${customerId}/save-property`,
    { propertyData },
  );
  return res.data;
};

const updateProperty = async (data) => {
  const res = await axiosBackEnd.put(
    `/api/onboarding/properties/${data.customer_id}`,
    data,
  );
  return res.data;
};

// Self service - get property by user
const getPropertiesByUser = async (userId) => {
  const response = await axiosBackEnd.get(
    `/api/onboarding/users/${userId}/properties`,
  );
  return response.data;
};

export {
  getAllProperties,
  getPropertiesByCustomer,
  approveProperty,
  requestValidationProperty,
  removeProperties,
  getPropertyById,
  updateProperty,
  getPropertiesByUser,
  addProperty,
  approveSingleProperty,
};
